import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { orders } from '../utils/orders';

@Injectable()
export class BookingsQueryService {
    ordersValues = orders;

    public GET_BOOKING_BY_ORDERID_DATA: any;

    public UPDATE_SCHEDULE_BOOKING_BY_NODEID_DATA: any;

    constructor(public apollo: Apollo) {

        /*Get nodeId from booking for updating insReportId*/
        this.GET_BOOKING_BY_ORDERID_DATA =
            gql`                                
            query GetReturnSelectedId($orderId:Int!) {
            allScheduledBookings(condition:{scheduleBookingId:$orderId}) {
                edges {
                node {
                    nodeId
                    scheduleBookingId
                }
                }
            }
        }
    `;

        //Update data of schedule booking's insReportId
        this.UPDATE_SCHEDULE_BOOKING_BY_NODEID_DATA =
            gql`                                
            mutation UPDATE_SCHEDULE_BOOKING_BY_ORDERID($input: UpdateScheduledBookingInput!) {
            updateScheduledBooking(input: $input) {
                scheduledBooking{
                        insReportId
                }
            }
            }   
            `;

    }


    /*Get nodeId from booking for updating insReportId*/
    GET_SCHEDULE_BOOKING_BY_ORDERID(orderId) {
        return this.apollo.watchQuery({
            query: this.GET_BOOKING_BY_ORDERID_DATA,
            variables: {
                "orderId": orderId,
            },
            fetchPolicy: 'network-only'
        })
    }

    /*Update data of schedule booking's insReportId*/
    UPDATE_SCHEDULE_BOOKING(nodeId): any {
        console.log('nodeId', nodeId);
        return this.apollo.mutate({
            mutation: this.UPDATE_SCHEDULE_BOOKING_BY_NODEID_DATA,
            variables: {
                "input": {
                    "scheduledBookingPatch":
                    {
                        "bookingStatus": this.ordersValues.status.Accepted,
                        "assignedTo": window.localStorage.getItem('userUID'),
                        "acceptedDate": new Date()
                    },
                    "nodeId": nodeId
                }
            },
            fetchPolicy: 'no-cache'
        })
    }


    /*Update data of schedule booking's insReportId*/
    UPDATE_SCHEDULE_BOOKING_BY_OWNER(nodeId, status): any {
        console.log('nodeId', nodeId);
        return this.apollo.mutate({
            mutation: this.UPDATE_SCHEDULE_BOOKING_BY_NODEID_DATA,
            variables: {
                "input": {
                    "scheduledBookingPatch":
                    {
                        "bookingStatus": status,
                    },
                    "nodeId": nodeId
                }
            },
            fetchPolicy: 'no-cache'
        })
    }

}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/gql-query-mutation/scheduleBookings.ts